import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

interface LoadingGridProps {
    count: number;
}

const LoadingGrid: React.FC<LoadingGridProps> = ({ count }) => {
    return (
        <div className="w-full mt-12 grid grid-cols-1 lg:grid-cols-3 gap-8">
            {Array.from({ length: count }).map((_, index) => (
                <div
                    key={index}
                    className="border border-[#EAEBF0] rounded-[12px] w-full"
                >
                    <Skeleton
                        height={350}
                        width="100%"
                        className="rounded-[12px] bg-[#B1BFC2]"
                    />
                    <div className="w-full p-6 md:p-8">
                        <Skeleton height={24} width="60%" className="mb-4" />
                        <div className="flex items-center space-x-3 mt-3">
                            <Skeleton height={20} width={20} circle={true} />
                            <Skeleton height={16} width="50%" />
                        </div>
                        <Skeleton
                            height={48}
                            width="100%"
                            className="mt-6 rounded-md bg-[#317333]"
                        />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default LoadingGrid;
